/* TerraLife — ajouts aux favoris. Les favoris de Glozin vivent dans le navigateur
   (localStorage « glozin__wishlist-items », identifiants produit) : ce script repère un ajout
   après un clic sur un cœur et
   - l'annonce au reste du thème (événement « tl:wishlist-add », lu par terralife-insights.js
     pour la mesure d'usage, si les statistiques sont acceptées) ;
   - l'envoie à Klaviyo (« Added to Wishlist », avec le produit) si le marketing est accepté :
     Klaviyo le rattache au profil quand le visiteur est connu (clic d'e-mail, formulaire),
     ce qui permet des relances sur les favoris. */
(() => {
  const KEY = 'glozin__wishlist-items';
  const ids = () => {
    try {
      return new Set((JSON.parse(localStorage.getItem(KEY)) || []).map(String));
    } catch (e) {
      return new Set();
    }
  };
  const marketing = () => {
    const m = document.cookie.match(/(?:^|;\s*)tl_consent=([^;]+)/);
    if (!m) return false;
    const v = decodeURIComponent(m[1]);
    return v === 'granted' || /\.m1(\.|$)/.test(v);
  };

  /** The product's handle: from the card or pack line around the heart, else the product page. */
  const handleNear = (button) => {
    const scope = button.closest('.product-item, [class*="pack-line"], .cart-item, product-info, .product') || document;
    const link = scope.querySelector('a[href*="/products/"]');
    const from = (href) => {
      const m = href && href.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    };
    return (link && from(link.getAttribute('href'))) || from(location.pathname);
  };

  const toKlaviyo = async (handle) => {
    if (!marketing() || !handle) return;
    let product = null;
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
      if (res.ok) product = await res.json();
    } catch (e) {}
    if (!product) return;
    const image = product.featured_image ? (product.featured_image.startsWith('//') ? `https:${product.featured_image}` : product.featured_image) : null;
    const props = {
      ProductID: product.id,
      ProductName: product.title,
      ProductHandle: product.handle,
      URL: `${location.origin}/products/${product.handle}`,
      ImageURL: image,
      Price: product.price / 100,
      Available: !!product.available,
      Categories: product.type ? [product.type] : [],
    };
    const queue = window.klaviyo || (window._learnq = window._learnq || []);
    queue.push(['track', 'Added to Wishlist', props]);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest && event.target.closest('button-wishlist');
      if (!button) return;
      const id = String(button.dataset.productId || '');
      const before = ids();
      if (!id || before.has(id)) return;
      // Glozin writes the list on its own click handler: look right after.
      setTimeout(() => {
        if (!ids().has(id)) return;
        const handle = handleNear(button);
        document.dispatchEvent(new CustomEvent('tl:wishlist-add', { detail: { id, handle } }));
        toKlaviyo(handle);
      }, 300);
    },
    true
  );
})();
